import { useState, useEffect } from "react";

function useIsMounted(enforceDelay = false, delayTime = 1000) {
  const [isMounted, setIsMounted] = useState(false);

  useEffect(() => {
    if (enforceDelay) {
      const timer = setTimeout(() => {
        setIsMounted(true);
      }, delayTime);

      return () => clearTimeout(timer);
    } else {
      setIsMounted(true);
    }
  }, [enforceDelay, delayTime]);

  return isMounted;
}

export default useIsMounted;
